"use strict";
exports.__esModule = true;
exports.EvtError = void 0;
var _1 = require("./EvtError.Timeout");
var _2 = require("./EvtError.Detached");
var EvtError;
(function (EvtError) {
    EvtError.Timeout = _1.Timeout;
    EvtError.Detached = _2.Detached;
})(EvtError = exports.EvtError || (exports.EvtError = {}));
//# sourceMappingURL=EvtError.js.map